// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Panel — fullscreen overlay with toolbar + sidebar/content layout
   ============================================ */

.grb-widget--overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--grb-color-overlay);
  z-index: var(--grb-z-index, 9999);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}

.grb-widget--overlay.grb-widget--visible {
  opacity: 1;
  visibility: visible;
}

/* Main panel — full viewport */
.grb-widget--panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--grb-color-background);
  z-index: calc(var(--grb-z-index, 9999) + 1);
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.grb-widget--panel.grb-widget--visible {
  transform: translateY(0);
}

/* Toolbar — search input + find button + close button */
.grb-widget--toolbar {
  display: flex;
  align-items: center;
  gap: 0;
  height: 56px;
  border-bottom: 1px solid var(--grb-color-border);
  flex-shrink: 0;
}

/* Toolbar filters label — same width as sidebar */
.grb-widget--toolbar-filters-label {
  width: var(--grb-sidebar-width);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: var(--grb-spacing-sm);
  padding: 0 var(--grb-spacing-md);
  height: 100%;
  font-size: var(--grb-font-size-base);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border-right: 1px solid var(--grb-color-border);
}

.grb-widget--toolbar-filters-label svg {
  flex-shrink: 0;
  stroke: var(--grb-color-text);
}

.grb-widget--filters-badge {
  display: none;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: var(--grb-color-primary);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0;
  text-transform: none;
}

.grb-widget--filters-badge:not(:empty) {
  display: inline-flex;
}

/* Body — sidebar + content */
.grb-widget--panel-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* Sidebar (filters) */
.grb-widget--sidebar {
  width: var(--grb-sidebar-width);
  flex-shrink: 0;
  border-right: 1px solid var(--grb-color-border);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
}

/* Content area (results) */
.grb-widget--content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: var(--grb-color-background);
}

/* Mobile: sidebar becomes top sheet or hidden */
@media (max-width: 768px) {
  .grb-widget--toolbar-filters-label {
    display: none;
  }

  .grb-widget--panel-body {
    flex-direction: column;
  }

  .grb-widget--sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--grb-color-border);
    max-height: none;
    overflow-y: visible;
  }

  .grb-widget--sidebar.grb-widget--sidebar-collapsed {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/panel.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,iCAAiC;EACjC,UAAU;EACV,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,YAAY;EACZ,gDAAgD;EAChD,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE,OAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gDAAgD;IAChD,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================\n   Panel — fullscreen overlay with toolbar + sidebar/content layout\n   ============================================ */\n\n.grb-widget--overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--grb-color-overlay);\n  z-index: var(--grb-z-index, 9999);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n}\n\n.grb-widget--overlay.grb-widget--visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Main panel — full viewport */\n.grb-widget--panel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--grb-color-background);\n  z-index: calc(var(--grb-z-index, 9999) + 1);\n  display: flex;\n  flex-direction: column;\n  transform: translateY(100%);\n  transition: transform 0.3s ease;\n}\n\n.grb-widget--panel.grb-widget--visible {\n  transform: translateY(0);\n}\n\n/* Toolbar — search input + find button + close button */\n.grb-widget--toolbar {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  height: 56px;\n  border-bottom: 1px solid var(--grb-color-border);\n  flex-shrink: 0;\n}\n\n/* Toolbar filters label — same width as sidebar */\n.grb-widget--toolbar-filters-label {\n  width: var(--grb-sidebar-width);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--grb-spacing-sm);\n  padding: 0 var(--grb-spacing-md);\n  height: 100%;\n  font-size: var(--grb-font-size-base);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  border-right: 1px solid var(--grb-color-border);\n}\n\n.grb-widget--toolbar-filters-label svg {\n  flex-shrink: 0;\n  stroke: var(--grb-color-text);\n}\n\n.grb-widget--filters-badge {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 10px;\n  background: var(--grb-color-primary);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.grb-widget--filters-badge:not(:empty) {\n  display: inline-flex;\n}\n\n/* Body — sidebar + content */\n.grb-widget--panel-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Sidebar (filters) */\n.grb-widget--sidebar {\n  width: var(--grb-sidebar-width);\n  flex-shrink: 0;\n  border-right: 1px solid var(--grb-color-border);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Content area (results) */\n.grb-widget--content {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  background: var(--grb-color-background);\n}\n\n/* Mobile: sidebar becomes top sheet or hidden */\n@media (max-width: 768px) {\n  .grb-widget--toolbar-filters-label {\n    display: none;\n  }\n\n  .grb-widget--panel-body {\n    flex-direction: column;\n  }\n\n  .grb-widget--sidebar {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid var(--grb-color-border);\n    max-height: none;\n    overflow-y: visible;\n  }\n\n  .grb-widget--sidebar.grb-widget--sidebar-collapsed {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
